import React, { useContext, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import { useTheme } from '../../contexts/ThemeContext';
import { AuthContext } from '../../contexts/AuthContext';
import ConnectBrokerContent from './ConnectBrokerContent';

/**
 * Standalone Connect Broker modal (sidebar, empty states, etc.).
 * Orientation onboarding embeds ConnectBrokerContent in its own single shell
 * instead of opening this modal on top of another.
 */
export default function ConnectBrokerModal({ show, onHide }) {
  const { colors } = useTheme();
  const { user, refreshUserSettings } = useContext(AuthContext);
  const [busy, setBusy] = useState(false);

  const handleClose = () => {
    if (busy) return;
    setBusy(false);
    onHide?.();
  };

  useEffect(() => {
    if (!show || !user?.token) return;
    refreshUserSettings?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, user?.token]);

  useEffect(() => {
    if (!show) setBusy(false);
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      backdrop={busy ? 'static' : true}
      keyboard={!busy}
      backdropClassName="trade-risk-quick-setup-backdrop"
      className="trade-risk-quick-setup-modal connect-broker-onboarding-modal onboarding-flow-modal"
      dialogClassName="trade-risk-quick-setup-dialog connect-broker-modal connect-broker-modal--fixed onboarding-flow-dialog"
      contentClassName="trade-risk-quick-setup-content"
      style={{ zIndex: 10050 }}
    >
      <Modal.Body
        style={{
          background: colors.bgPrimary || colors.bgSecondary,
          padding: '28px 24px 28px',
          position: 'relative',
        }}
        className="connect-broker-modal-body"
      >
        {!busy && (
          <button
            type="button"
            onClick={handleClose}
            aria-label="Close"
            style={{
              position: 'absolute',
              top: 16,
              right: 16,
              background: 'none',
              border: 'none',
              color: colors.textMuted,
              padding: 6,
              cursor: 'pointer',
              zIndex: 1,
            }}
          >
            <X size={22} />
          </button>
        )}
        <ConnectBrokerContent onBusyChange={setBusy} />
      </Modal.Body>
    </Modal>
  );
}
